export function calculatePercentage(numerator: number, denominator: number) {
    if (denominator === 0) {
        return 0;
    }
    return (numerator / denominator) * 100;
}

export function roundNumber(num: number, decimalPlaces?:number) {
    return Number(num.toFixed(decimalPlaces));
}